import { render, staticRenderFns } from "./WebSisteBottomNavigation.vue?vue&type=template&id=ffd782ac&scoped=true"
import script from "./WebSisteBottomNavigation.vue?vue&type=script&lang=js"
export * from "./WebSisteBottomNavigation.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./WebSisteBottomNavigation.vue?vue&type=style&index=0&id=ffd782ac&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./WebSisteBottomNavigation.vue?vue&type=style&index=1&id=ffd782ac&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ffd782ac",
  "7aca0dec"
  
)

export default component.exports